import { decodeGarmentGeometry, type GarmentGeometry, type ISceneEntity } from '@seddi/scene';
import type { LoadingManager } from '@seddi/three';
import { load as loadFile } from '../loaders/binaryAssetLoader';

/**
 * Load garment geometry.
 * @param url = Resource URL.
 * @param children - Scene children.
 * @param manager - Loading manager.
 */
export const load = async (
  url: string,
  children: ISceneEntity[],
  manager: LoadingManager,
): Promise<GarmentGeometry> => {
  const bytes = await loadFile(url, manager);
  const data = decodeGarmentGeometry(bytes, children);
  return data;
};
